import type { PresetStatusColorType } from "antd/es/_util/colors";
import { ValidationStatusEnum } from "../../services/client/types.gen";

export const getStatusColor = (
  status?: ValidationStatusEnum,
): PresetStatusColorType => {
  switch (status) {
    case "OK":
      return "success";
    case "WARNING":
      return "warning";
    case "ERROR":
      return "error";
    case "UNKNOWN":
    default:
      return "default";
  }
};

export const getStatusText = (status?: ValidationStatusEnum): string => {
  switch (status) {
    case "OK":
      return "OK";
    case "WARNING":
      return "Warning";
    case "ERROR":
      return "Error";
    case "UNKNOWN":
      return "Unknown";
    default:
      return "N/A";
  }
};
